/**
 * @file   src\mobile\components\SendIntroduction\AddProperty.js
 * @brief  This file is responsible for handling add property in send introductions section
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { pageURLs } from "@/constants";
import { getUserId, removeLocalStorage } from "../../../helpers/common";
import { fetchUserStatistics } from "../../../actions/userprofile";
import {
  INVENTORY_KEY,
  INVENTORY_KEY_TEMP,
  USER_TYPE_AGENT,
} from "../../../constants/common";
import AddPropertyPlus from "../../../images/add-property-plus-icon.svg";

const AddProperty = (props) => {
  const { userDetails } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = getUserId();
  const userStatictics = useSelector(
    (state) => state?.userProfile?.userStatictics
  );
  const userPrivileges = useSelector(
    (state) => state?.userProfile?.userPrivileges
  );
  const [userCount, setUserCount] = useState({});
  const [allowedCount, setAllowedCount] = useState({});
  useEffect(() => {
    const payload = {
      UserPlanId: userDetails?.User_Plan_Id,
    };

    dispatch(fetchUserStatistics(payload));
  }, [userDetails]);

  useEffect(() => {
    if (userPrivileges !== null && userPrivileges.length > 0) {
      setAllowedCount(userPrivileges[0]);
    } else {
      setAllowedCount({});
    }
  }, [userPrivileges]);

  useEffect(() => {
    if (userStatictics !== null && userStatictics.length > 0) {
      setUserCount(userStatictics[0]);
    } else {
      setUserCount({});
    }
  }, [userStatictics]);

  /**
   * To handle add property based on user plan
   */
  const handleAddProperty = () => {
    if (userCount?.Inventory >= allowedCount?.Inventory) {
      navigate(pageURLs.updatePlan, {
        state: { isFromSettings: true },
      });
    } else {
      removeLocalStorage(INVENTORY_KEY);
      removeLocalStorage(INVENTORY_KEY_TEMP);
      navigate(pageURLs.mobileCreateInventory, {
        state: { isFromSendIntroduction: true },
      });
    }
  };

  return (
    <>
      <a role="button" href={void 0} onClick={() => handleAddProperty()}>
        <div className="my-property-mob pt-12">
          <div className="add-property-smallbtn-mob">
            <img src={AddPropertyPlus} />
          </div>
          <div className="my-property-details-mob">
            <h3 className="mb-0">Add your property</h3>
          </div>
        </div>
      </a>
    </>
  );
};

export default AddProperty;
